import { render } from "./company-system-categories.vue?vue&type=template&id=544d7d1f&ts=true"
import script from "./company-system-categories.vue?vue&type=script&lang=ts"
export * from "./company-system-categories.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__